import { render, staticRenderFns } from "./fr.vue?vue&type=template&id=76b8b56e"
import script from "./fr.vue?vue&type=script&lang=js"
export * from "./fr.vue?vue&type=script&lang=js"
import style0 from "./fr.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-deposit/fr.vue
// module id = 30nP
// module chunks = 0